<template>
    <div class="grid">
        <div class="unit whole">
            <h1>{{ lang.get('Avatars') }}</h1>
            <p class="lead">{{ lang.get('Choose your avatar.') }}</p>
        </div>
    </div>
    <div class="grid">
        <div class="unit whole">
            <div class="d-flex mb-5 w-100">
                <v-btn-toggle
                    v-model="category"
                    mandatory
                    border
                    divided
                    class="w-100"
                    color="secondary-container"
                    base-color="#EDF6F9"
                    style="border-radius: 12px; border-color: #798186"
                >
                    <v-btn value="Animals" class="flex-fill" prepend-icon="mdi-cat" style="border-radius: 0"
                        >Animals</v-btn
                    >
                    <v-btn value="Creatures" class="flex-fill" prepend-icon="mdi-owl" style="border-radius: 0"
                        >Creatures</v-btn
                    >
                    <v-btn
                        value="People"
                        class="flex-fill"
                        prepend-icon="mdi-account-multiple-outline"
                        style="border-radius: 0"
                        >People</v-btn
                    >
                </v-btn-toggle>
            </div>
            <div class="panel" style="border-radius: 12px">
                <div v-for="(i, lot) in Math.ceil(avatars.length / 5)" :key="i" class="d-flex">
                    <div
                        v-for="avatar in avatars.filter((a) => a.category === category).slice(lot * 5, lot * 5 + 5)"
                        :key="avatar.file"
                        class="avatar pa-2"
                        :class="{ selected: avatar.file === pupil?.avatar }"
                    >
                        <img
                            :alt="avatarName(avatar.file)"
                            :src="`/common/img/avatars/${avatar.file}`"
                            @click="pick(avatar.file)"
                            width="160"
                            height="160"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
const store = usePupilStore();
store.fetchPupil();
const { pupil } = storeToRefs(store);
const lang = useLang();
const router = useRouter();
definePage({ meta: { area: 'avatar' } });

const category = ref<'People' | 'Animals' | 'Creatures'>('Animals');

type Avatar = {
    file: string;
    category: 'People' | 'Animals' | 'Creatures';
};

const avatars: Avatar[] = [
    { file: 'Avatar1.jpg', category: 'People' },
    { file: 'Avatar2.jpg', category: 'People' },
    { file: 'Avatar3.jpg', category: 'People' },
    { file: 'Avatar4.jpg', category: 'People' },
    { file: 'Avatar6.jpg', category: 'Animals' },
    { file: 'Avatar7.jpg', category: 'Animals' },
    { file: 'Avatar8.jpg', category: 'Animals' },
    { file: 'Avatar9.jpg', category: 'Animals' },
    { file: 'Avatar10.jpg', category: 'Creatures' },
    { file: 'Avatar11.jpg', category: 'Creatures' },
    { file: 'Avatar12.jpg', category: 'People' },
    { file: 'Avatar13.jpg', category: 'People' },
    { file: 'Avatar15.jpg', category: 'Animals' },
    { file: 'Avatar16.jpg', category: 'Animals' },
    { file: 'Avatar17.jpg', category: 'Animals' },
    { file: 'Avatar22.jpg', category: 'Animals' },
    { file: 'Avatar27.jpg', category: 'Animals' },
    { file: 'Avatar28.jpg', category: 'Animals' },
    { file: 'Avatar29.jpg', category: 'People' },
    { file: 'Avatar32.jpg', category: 'Animals' },
    { file: 'Avatar33.jpg', category: 'People' },
    { file: 'Avatar36.jpg', category: 'People' },
    { file: 'Avatar38.jpg', category: 'Animals' },
    { file: 'Avatar39.jpg', category: 'Animals' },
    { file: 'Avatar42.jpg', category: 'Creatures' },
    { file: 'Avatar44.jpg', category: 'Animals' },
    { file: 'Avatar49.jpg', category: 'Animals' },
    { file: 'Avatar53.jpg', category: 'Animals' },
    { file: 'Avatar57.jpg', category: 'Animals' },
    { file: 'Avatar59.jpg', category: 'Creatures' },
    { file: 'Avatar60.jpg', category: 'Creatures' },
    { file: 'Avatar61.jpg', category: 'Creatures' },
    { file: 'Avatar62.jpg', category: 'Creatures' },
    { file: 'Avatar64.jpg', category: 'Animals' },
    { file: 'Avatar65.jpg', category: 'Creatures' },
    { file: 'Avatar66.jpg', category: 'Animals' },
    { file: 'Avatar71.jpg', category: 'Creatures' },
    { file: 'Avatar72.jpg', category: 'Animals' },
    { file: 'Avatar73.jpg', category: 'Animals' },
    { file: 'Avatar78.jpg', category: 'Creatures' },
    { file: 'Avatar80.jpg', category: 'Creatures' },
    { file: 'Avatar81.jpg', category: 'Creatures' },
    { file: 'Avatar82.jpg', category: 'Creatures' },
    { file: 'Avatar85.jpg', category: 'Creatures' },
    { file: 'Avatar86.jpg', category: 'Creatures' },
    { file: 'Avatar87.jpg', category: 'Creatures' },
    { file: 'Avatar88.jpg', category: 'Creatures' },
    { file: 'Avatar89.jpg', category: 'Creatures' },
    { file: 'Avatar90.jpg', category: 'Creatures' },
    { file: 'default.jpg', category: 'Creatures' },
    { file: 'lady-mcb.jpg', category: 'People' },
    { file: 'macbeth.jpg', category: 'People' },
    { file: 'villan.jpg', category: 'People' },
    { file: 'Barkleys-Diary.jpg', category: 'Animals' },
    { file: 'Croc.jpg', category: 'Animals' },
    { file: 'Cute-cat.jpg', category: 'Animals' },
    { file: 'Eeyore.jpg', category: 'Animals' },
    { file: 'Hare.jpg', category: 'Animals' },
    { file: 'Miss-Mittens.jpg', category: 'Animals' },
    { file: 'Pi.jpg', category: 'Animals' },
    { file: 'Short-Girraffe.jpg', category: 'Animals' },
    { file: 'Squirrel.jpg', category: 'Animals' },
    { file: 'Afanc.jpg', category: 'Creatures' },
    { file: 'Dragon1.jpg', category: 'Creatures' },
    { file: 'Dragon2.jpg', category: 'Creatures' },
    { file: 'Dragon5.jpg', category: 'Creatures' },
    { file: 'Dragon6.jpg', category: 'Creatures' },
    { file: 'Dragon9.jpg', category: 'Creatures' },
    { file: 'Griffin.jpg', category: 'Creatures' },
    { file: 'Mermaid.jpg', category: 'Creatures' },
    { file: 'Nessy.jpg', category: 'Creatures' },
    { file: 'Unicorn.jpg', category: 'Creatures' },
    { file: 'Werewolf.jpg', category: 'Creatures' },
    { file: 'Alicorn.jpg', category: 'People' },
    { file: 'Brodie.jpg', category: 'People' },
    { file: 'Dancer.jpg', category: 'People' },
    { file: 'Gravity.jpg', category: 'People' },
    { file: 'Home-time-boy.jpg', category: 'People' },
    { file: 'Indian-Girl.jpg', category: 'People' },
    { file: 'Kanoni.jpg', category: 'People' },
    { file: 'Lightning-Strike.jpg', category: 'People' },
    { file: 'Mighty.jpg', category: 'People' },
    { file: 'Pat-&-I-1.jpg', category: 'People' },
    { file: 'Puddle-Dancer.jpg', category: 'People' },
    { file: 'Robin-Hood.jpg', category: 'People' },
    { file: 'Robot.jpg', category: 'People' },
    { file: 'Rosie-Twinkletoes.jpg', category: 'People' },
    { file: 'Snow-White.jpg', category: 'People' },
    { file: 'We-all-play-ball-boy.jpg', category: 'People' },
    { file: 'We-all-play-ball-girl.jpg', category: 'People' },
    { file: 'We-all-play-ball-teacher.jpg', category: 'People' },
];

watch(
    pupil,
    () => {
        category.value = avatars.find((a) => a.file === pupil.value?.avatar)?.category || 'Animals';
    },
    { immediate: true },
);

function avatarName(avatar: string) {
    return avatar.replace('.jpg', '').replace('-', ' ');
}

async function pick(avatar: string) {
    await store.updatePupil({ avatar });
    await router.push('/pupil/profile');
}
</script>
<style lang="scss" scoped>
.avatar {
    cursor: pointer;
    img {
        border: 1px solid rgba(var(--v-theme-outline-variant));
        border-radius: 12px;
        &:hover {
            border: 4px solid rgba(var(--v-theme-outline-variant));
            transition: border 0.1s;
        }
    }
    &.selected img {
        border: 4px solid rgba(var(--v-theme-brand));
    }
}
</style>
